import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./shared/styles/global.css";
import "./shared/styles/app-chrome.css";
import "./shared/styles/service-page.css";
import "remixicon/fonts/remixicon.css";
import { protectMedia } from "./shared/utils/protectMedia";

protectMedia();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
